import { faShareNodes } from "@fortawesome/pro-regular-svg-icons/faShareNodes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { MprcIconButtonDropdown } from "components";
import { MprcDropdownItem } from "components/MprcIconButtonDropdown";
import { MemberType, ShareTrainingTarget, TrainingShareOption } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { TrainingRecommendDialog } from "views/lms/dialogs/TrainingRecommendDialog";
import { TrainingShareDialog } from "views/lms/dialogs/TrainingShareDialog";

///////////////////////////////////////////////////////////////////////////////

export interface IShareButtonProps {
    trainingId: string;
    trainingName: string;
    shareOption: TrainingShareOption;
    readonly?: boolean;
    trainingHasAudienceDefined: boolean;
    enableShareInChannelAndLists: boolean;
}

type ShareButtonOptions = "recommendToUsers" | "recommendToGroups" | "shareChannel" | "shareList";

export const TrainingShareButton = (props: IShareButtonProps) => {
    const [dialog, setDialog] = useState<any>();
    const { t } = useTranslation("lms");

    ///
    const getMenuItems = (): MprcDropdownItem<ShareButtonOptions>[] => {
        var arr: MprcDropdownItem<ShareButtonOptions>[] = [];

        arr.push({ text: t("Training.Share.OptionRecommendedToUsers") + "...", value: "recommendToUsers" });
        if (!props.trainingHasAudienceDefined) arr.push({ text: t("Training.Share.OptionRecommendedToGroups") + "...", value: "recommendToGroups" });

        if (props.enableShareInChannelAndLists) {
            arr.push({ text: t("Training.Share.OptionShareInChannel") + "...", value: "shareChannel" });
            arr.push({ text: t("Training.Share.OptionShareInList") + "...", value: "shareList" });
        }

        return arr;
    };

    ///
    const handleMenuItem = (option: ShareButtonOptions) => {
        switch (option) {
            case "recommendToUsers":
                setDialog(
                    <TrainingRecommendDialog
                        {...props}
                        memberType={MemberType.User}
                        onClose={() => setDialog(null)}
                    />
                );
                break;
            case "recommendToGroups":
                setDialog(
                    <TrainingRecommendDialog
                        {...props}
                        memberType={MemberType.Group}
                        onClose={() => setDialog(null)}
                    />
                );
                break;

            default:
                setDialog(
                    <TrainingShareDialog
                        {...props}
                        shareOption={option == "shareChannel" ? ShareTrainingTarget.Channel : ShareTrainingTarget.List}
                        onClose={() => setDialog(null)}
                    />
                );
                break;
        }
    };

    return props.shareOption == TrainingShareOption.Denied
        ? null
        : (
            <>
                {dialog}

                <Typography variant="iconText" component="div">
                    <MprcIconButtonDropdown
                        icon={<FontAwesomeIcon icon={faShareNodes} fixedWidth />}
                        items={getMenuItems()}
                        onChange={handleMenuItem}
                        separator="blank"
                        disabled={props.readonly}
                        title={t("Training.Share.ShareButtonTooltip")}
                    />
                </Typography>
            </>
        );
};
